import * as React from "react"
import { cn } from "../../lib/utils"
import { useScrollReveal } from "../../hooks/useScrollReveal"

interface SectionWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  wide?: boolean
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ className, wide = false, children, ...props }) => {
  const { ref, isVisible } = useScrollReveal(0.08);

  return (
    <section
      ref={ref}
      className={cn(
        "relative py-24 md:py-32 px-6 transition-all duration-[800ms] ease-out",
        wide ? "max-w-7xl" : "max-w-6xl",
        "mx-auto w-full",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
        className
      )}
      {...props}
    >
      {children}
    </section>
  )
}

export { SectionWrapper }
